import React from "react";
import { useNavigate } from "react-router-dom";
import { FaEnvelope, FaFileDownload } from "react-icons/fa";
import "./ProgramDetails.css";
const image = require("./assets/images/additive-manufacturing.png")
const MTechAdditiveManufacturing = () => {
  const navigate = useNavigate();

  return (
    <div className="prog-main-container">
      <div className="program-container">
        <button className="back-btn" onClick={() => navigate(-1)}>
          ← Back to Programs
        </button>
        <header className="header">
          <h1 className="fade-in delay">M.Tech in Additive Manufacturing</h1>
        </header>
        <section className="description fade-in delay-2">
          <p>
            Additive Manufacturing is revolutionizing production. This M.Tech program covers advanced 3D printing, material innovation, and digital manufacturing technologies to equip you for tomorrow’s industry.
          </p>
        </section>
        <img src={image} alt="" className="prog_img"/>
        <section className="cards">
          <div className="card faculty fade-in delay-3">
            <h2>Faculty Coordinators</h2>
            <div className="contact"><FaEnvelope /> <a href="mailto:psonkar@des.iith.ac.in">Dr. Prasad Onkar</a></div>
            <div className="contact"><FaEnvelope /> <a href="mailto:falguni@bme.iith.ac.in">Dr. Falguni Pati</a></div>
          </div>
          <div className="card resources fade-in delay-4">
            <h2>Resources</h2>
            {["Brochure", "Time Table", "Curriculum"].map(name => (
              <div key={name} className="download"><FaFileDownload /> <a href={`#${name.replace(" ","-")}`}>Download {name}</a></div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default MTechAdditiveManufacturing;
